import { createContext, useContext, useState } from "react";

const CalmModeContext = createContext({ isCalm: false, setIsCalm: () => {} });

export function CalmModeProvider({ children }) {
  const [isCalm, setIsCalm] = useState(false);
  return (
    <CalmModeContext.Provider value={{ isCalm, setIsCalm }}>
      {children}
    </CalmModeContext.Provider>
  );
}

export function useCalmMode() {
  return useContext(CalmModeContext);
}
